import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/brands").then((r) => setBrands(r.data)).catch(() => {}); }, []);

  return (
    <div className="container-furn py-12">
      <div className="mb-10 border-b border-border pb-6">
        <span className="overline">The best in the business</span>
        <h1 className="mt-1 font-display text-4xl font-bold uppercase tracking-tight md:text-5xl">Shop by Brand</h1>
        <p className="mt-2 max-w-xl text-muted-foreground">We stock all the leading names in specialist angling — from carp giants to bait specialists.</p>
      </div>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {brands.map((b, i) => (
          <Link key={b.name} to={`/shop?brand=${encodeURIComponent(b.name)}`} data-testid={`brand-tile-${b.name}`} className="group flex min-h-[130px] flex-col items-center justify-center gap-2 border border-border bg-card p-6 text-center transition-colors hover:border-accent animate-fade-up" style={{ animationDelay: `${(i % 8) * 50}ms` }}>
            <span className="font-display text-xl font-semibold uppercase tracking-wide group-hover:text-accent transition-colors">{b.name}</span>
            <span className="text-xs text-muted-foreground">{b.count} products</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
